import OrderActions from './OrderActions';

const ORDER_ACTIONS_SELECTOR = '[data-order-actions]';

class OrderActionsFactory {
  constructor() {
    let els = document.querySelectorAll(ORDER_ACTIONS_SELECTOR);

    Array.prototype.forEach.call(els, el => {
      new OrderActions(el);
    });
  }
}

export default OrderActionsFactory;



// WEBPACK FOOTER //
// ./src/javascripts/OrderActionsFactory.js